<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { GroupingError } from '@/store/modules/stay/types'

defineProps<{
  errors: GroupingError[]
}>()

const { t } = useI18n()
</script>

<template>
  <div
    v-if="errors.length > 0"
    class="grouping-error-block"
  >
    <p class="grouping-error-block__title">
      {{ t('stayDisplayer.grouping.errorTitle') }}
    </p>
    <div
      v-for="error in errors"
      :key="error.code"
      class="grouping-error-block__row"
    >
      <div
        class="grouping-error-block__code"
        :class="{ 'grouping-error-block__code--critical': error.critical }"
      >
        {{ error.code }}
      </div>
      <span class="grouping-error-block__description">{{ error.description }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/design-system/tokens/colors';

.grouping-error-block {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &__title {
    font-size: 15px;
    font-weight: 900;
    color: #000000;
    margin: 0;
  }

  &__row {
    display: flex;
    gap: 5px;
    align-items: flex-start;
  }

  &__code {
    background-color: $grouping-badge-error-bg;
    color: $grouping-error-code-color;
    font-size: 12px;
    font-weight: 900;
    padding: 0 10px;
    border-radius: 3px;
    width: 40px;
    text-align: center;
    flex-shrink: 0;
  }

  &__description {
    font-size: 14px;
    font-weight: 500;
  }
}
</style>
